/* eslint-disable tss-unused-classes/unused-classes */

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  inputFields: {
    '& > label': {
      ...theme.typography.paragraphRegular,
    },
  },
  typeSelection: {
    '& > label': {
      ...theme.typography.paragraphRegular,
    },
    '& >.MuiCard-root': {
      background: theme.palette.background.layer1,
      padding: 2,
      '& .MuiChip-outlined': {
        background: theme.palette.background.layer1,
        borderRadius: theme.spacing(1.5),
        '>.MuiChip-label': {
          padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        },
        '&.MuiChip-selected': {
          background: theme.palette.background.paper,
          color: theme.palette.text.secondary,
        },
      },
    },
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    background: theme.palette.background.default,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    alignItems: 'center',
    border: `1px solid ${theme.palette.border.light}`,
    boxShadow: 'none',
  },
  selectProps: {
    '>label': {
      ...theme.typography.paragraphRegular,
    },
  },
  card: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    background: theme.palette.background.default,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    border: `1px solid ${theme.palette.border.light}`,
    boxShadow: 'none',
    overflow: 'auto',
    '>label': {
      ...theme.typography.paragraphRegular,
    },
  },
  cardControl: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    alignItems: 'center',
    border: `1px solid ${theme.palette.border.light}`,
    '>div': {
      boxShadow: 'none',
    },
  },
  taxGroupCard: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    alignItems: 'center',
    border: `1px solid ${theme.palette.border.light}`,
    '>div': {
      boxShadow: 'none',
    },
    background: theme.palette.background.default,
  },
  placeholder: {
    ...theme.typography.paragraphRegular,
  },
  resetBtn: {
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(1),
    cursor: 'pointer',
  },
  taxInfoBtn: {
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1),
    cursor: 'pointer',
  },
  arrow: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  dropDown: {
    '& >.MuiInputBase-root': {
      background: theme.palette.background.paper,
    },
  },
  inputLabel: {
    marginTop: theme.spacing(0.5),
    ...theme.typography.paragraphRegular,
  },
  checkboxList: {
    margin: 0,
    padding: `${theme.spacing(1)} ${theme.spacing(1)}`,
    borderTop: `1px solid ${theme.palette.border.light}`,
    '&:last-child': {
      borderBottom: `1px solid ${theme.palette.border.light}`,
    },
  },
}));

export default useStyles;
